import React from "react";
import { Redirect } from "react-router-dom";

const PlanCheckoutProviders = () => {
  return <Redirect to="/financeiro-aberto" />;
};

export default PlanCheckoutProviders;
